export const REGISTRATION_PASSWORD_HINT =
  "Password must be 8 characters, one uppercase, one lowercase, one number and one special character";

export function getRegistrationPasswordFieldSx(error, primaryColor, colorizeHint = false) {
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
      backgroundColor: "rgba(249, 249, 249, 0.8)",
      "& fieldset": {
        borderColor: error ? "#d32f2f" : "#E0E0E0",
        borderWidth: "2px",
      },
      "&:hover fieldset": {
        borderColor: error ? "#d32f2f" : primaryColor,
      },
      "&.Mui-focused fieldset": {
        borderColor: error ? "#d32f2f" : primaryColor,
      },
    },
    "& .MuiInputBase-input::placeholder": {
      color: "text.secondary",
      opacity: 0.7,
    },
    "& .MuiFormHelperText-root": {
      margin: "4px 0 0 0",
      fontSize: "0.75rem",
      ...(colorizeHint ? { color: error ? "#d32f2f" : "text.secondary" } : {}),
    },
  };
}
